export default __webpack_public_path__ + "images/945d167cdd681b26cd32b6a3aad4fd9f-media_small.webp";